module.exports = __webpack_public_path__ + "static/hero2_mob-fe47ab234c7f45aa660fe99b19eaa28d.jpg";